<template>
  <div>
    <!-- <div style="display: flex; justify-content: space-between">
      <div style="font-size: 20px">消息通知</div>
    </div> --> 
    <div class="acontent" v-if="adviseList.length != 0">
      <div class="reply-list" v-for="(item, i) in adviseList" :key="i">
        <div class="root-reply-container">
          <div class="root-reply-avatar">
            <!-- <img src="../../assets/icon/组 74(1).png" alt="" /> -->
            <svg
              t="1709519751715"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="16819"
              width="42"
              height="42"
            >
              <path
                d="M512.4096 514.7136m-450.816 0a450.816 450.816 0 1 0 901.632 0 450.816 450.816 0 1 0-901.632 0Z"
                fill="#FF9552"
                p-id="16820"
              ></path>
              <path
                d="M726.4256 271.616h-428.032c-38.8608 0-70.3488 31.488-70.3488 70.3488v338.3296c0 38.8608 31.488 70.3488 70.3488 70.3488h135.0144c6.5024 0 12.6464 2.7136 16.9984 7.5264l50.5344 55.7568a22.9376 22.9376 0 0 0 33.3312 0.7168l56.4736-57.1904c4.3008-4.352 10.1888-6.8096 16.3328-6.8096h119.296c38.8608 0 70.3488-31.488 70.3488-70.3488V341.9136c0.0512-38.8096-31.4368-70.2976-70.2976-70.2976z m-370.432 288.8704c-23.0912 0-41.8304-18.7392-41.8304-41.8304s18.7392-41.8304 41.8304-41.8304 41.8304 18.7392 41.8304 41.8304-18.7392 41.8304-41.8304 41.8304z m159.1296 0c-23.0912 0-41.8304-18.7392-41.8304-41.8304s18.7392-41.8304 41.8304-41.8304 41.8304 18.7392 41.8304 41.8304-18.688 41.8304-41.8304 41.8304z m159.1808 0c-23.0912 0-41.8304-18.7392-41.8304-41.8304s18.7392-41.8304 41.8304-41.8304 41.8304 18.7392 41.8304 41.8304-18.7392 41.8304-41.8304 41.8304z"
                fill="#FFFFFF"
                p-id="16821"
              ></path>
            </svg>
          </div>
          <div class="content-warp">
            <div class="user-info">
              <p class="user-name">{{ item.title }} <span  :class="['hifu',item.isReply==1?'red':'grren']">({{item.isReply==1?'已回复':'未回复'}})</span> </p>
            </div>
            <div class="root-message">
              <p class="root-reply">{{ item.advise }}</p>
              <div class="root-logo">
                <div
                  class="logos"
                  v-for="items in item.imgList"
                  :key="items.attachmentId"
                >
                  <img :src="items.url" />

                  <!-- <p class="fileName" @click="deait(items.url)"> 文件名: {{ items.name }}</p> -->
                </div>
              </div>
              <p class="reply-info">
                <span class="reply-time">{{ geshu(item.createTime) }}</span>
              </p>
            </div>
          </div>
        </div>
        <div class="sub-reply-container">
          <div class="sub-reply-list">
            <div
              class="sub-reply-item"
              v-for="items in item.replyList"
              :key="items.adviceId"
            >
              <div class="sub-contetn">
                <div class="sub-info">
                  <div class="sub-in-logo">
                    <svg
                      t="1709517969541"
                      class="icon"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="11328"
                      width="24"
                      height="24"
                    >
                      <path
                        d="M709.636697 565.984797c-25.163827-25.298034-54.320315-45.227785-86.697772-59.285977l-8.35439-3.657142 6.676802-6.173526c33.417562-30.867628 52.575623-74.652687 52.575622-119.981127 0-90.187156-73.37772-163.564875-163.598427-163.564876-90.187156 0-163.564875 73.37772-163.564875 163.564876 0 45.361992 19.15806 89.113499 52.575622 119.981127l6.676802 6.173526-8.35439 3.657142c-32.176147 13.991088-61.366186 33.920839-86.731324 59.285977-53.213106 53.246658-82.503801 124.040891-82.503801 199.364613 0 16.104849 13.118742 29.223591 29.223591 29.223591 16.104849 0 29.223591-13.118742 29.223591-29.223591 0-123.235649 100.252687-223.454784 223.454784-223.454784s223.488336 100.252687 223.488336 223.454784c0 16.104849 13.118742 29.223591 29.223591 29.223591s29.223591-13.118742 29.223591-29.223591c0-75.223067-29.324246-146.050852-82.537353-199.364613z m-199.398165-83.946527c-57.977457 0-105.151245-47.173788-105.151245-105.151245s47.173788-105.151245 105.151245-105.151245c58.011009 0 105.184797 47.173788 105.184797 105.151245s-47.173788 105.151245-105.184797 105.151245z"
                        p-id="11329"
                        fill="#8a8a8a"
                      ></path>
                      <path
                        d="M721.077851 16.977195H299.432765c-152.257929 0-276.131062 123.873132-276.131061 276.131062v421.611533c0 152.257929 123.873132 276.131062 276.131061 276.131062h421.645086c152.257929 0 276.131062-123.873132 276.131061-276.131062V293.141809c0-152.291481-123.873132-276.164613-276.131061-276.164614zM947.317431 714.753342c0 60.426737-23.553342 117.263434-66.264744 159.974836-42.711402 42.744954-99.514548 66.264744-159.974836 66.264745H299.432765c-60.426737 0-117.263434-23.553342-159.974836-66.264745-42.744954-42.744954-66.264744-99.581651-66.264744-159.974836V293.141809c0-60.426737 23.51979-117.229882 66.264744-159.974837C182.202883 90.422018 239.006029 66.868676 299.432765 66.868676h421.645086c60.426737 0 117.263434 23.553342 159.974836 66.264745C923.764089 175.878375 947.317431 232.68152 947.317431 293.141809v421.611533z"
                        p-id="11330"
                        fill="#673ab7"
                      ></path>
                    </svg>
                  </div>
                  <P> admin回复:</P>
                </div>
                <span class="sub-text">{{ items.advise }}</span>
              </div>

              <p class="reply-info">
                <span class="reply-time">{{ geshu(items.createTime) }}</span>
              </p>
            </div>
          </div>
        </div>
        <div class="delete">
          <el-popconfirm title="确定删除吗？" @confirm="deletes(item, i)">
            <svg
              t="1709520737902"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="36840"
              width="24"
              height="24"
              slot="reference"
            >
              <path
                d="M641.706667 3.413333h-256C177.493333 3.413333 3.413333 174.08 3.413333 385.706667v256c0 208.213333 170.666667 382.293333 382.293334 382.293333h256C849.92 1024 1024 853.333333 1024 641.706667v-256C1020.586667 174.08 849.92 3.413333 641.706667 3.413333z m54.613333 634.88c17.066667 17.066667 17.066667 40.96 0 58.026667-6.826667 6.826667-17.066667 13.653333-27.306667 13.653333s-20.48-3.413333-27.306666-13.653333L512 570.026667l-126.293333 126.293333c-6.826667 6.826667-17.066667 13.653333-27.306667 13.653333-10.24 0-20.48-3.413333-27.306667-13.653333-17.066667-17.066667-17.066667-40.96 0-58.026667l126.293334-126.293333-126.293334-126.293333c-17.066667-17.066667-17.066667-40.96 0-58.026667s40.96-17.066667 58.026667 0l126.293333 126.293333 126.293334-126.293333c17.066667-17.066667 40.96-17.066667 58.026666 0s17.066667 40.96 0 58.026667L570.026667 512l126.293333 126.293333z"
                fill="#E83828"
                p-id="36841"
              ></path>
            </svg>
          </el-popconfirm>
        </div>
      </div>
      <div class="page">
        <el-pagination
          background
          :current-page.sync="queryParam.page"
          :page-size.sync="queryParam.size"
          @current-change="CurrentChange"
          layout="prev, pager, next"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <el-empty v-else description="暂无内容"></el-empty>

  </div>
</template>

<script>
import api from "../../api";
import cookie from "@/api/cookie";
import * as moment from "moment";
export default {
  data() {
    return {
      adviseList: [],
      queryParam: {
        page: 1,
        size: 10,
      },
      total: 0,
    };
  },
  created() {
    this.getMessage();
  },
  methods: {
    geshu(createTime) {
      return moment(createTime).format("YYYY-MM-DD HH:mm:ss");
    },
    // 获取管理员通知
    getMessage() {
      api
        .getAdviseSS(cookie.getCookie("userId"), this.queryParam)
        .then(async (res) => {
          console.log(res, "1我是无芭芭拉");
          // this.adviseList = res.data.list;
          let xinArr = res.data.list.map(async (item) => {
            console.log(item.adviceId, "我跑不掉了拉低");
            await api
              .getAdviseId({ userAdviseId: item.adviceId })
              .then((res) => {
                item.imgList = res.data;
              });
            console.log(item, "我不是itmesdsd");
            return item;
          });

          await Promise.all(xinArr).then((ress) => {
            this.adviseList = ress;
            console.log(this.adviseList,'wi啥的')
            this.total = res.data.total;
          });
        });
    },
    CurrentChange() {
      this.getMessage();
    },
    // 查看附件
    deait(url) {
      window.open(url);
    },
    // 删除通知
    deletes(row, index) {
      api.deleteAdviseId(row.adviceId).then((res) => {
        this.adviseList.splice(index, 1);
        this.$message.success("删除成功");
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.acontent {
  .root-reply-container {
    padding: 22px 0 0px 80px;
    display: flex;

    .root-reply-avatar {
      margin-right: 20px;
      width: 42px;
      height: 42px;
      //   border-radius: 50%;
      overflow: hidden;
      cursor: pointer;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .content-warp {
      flex: 1;
      padding-bottom: 8px;
    }

    .user-info {
      margin-bottom: 15px;
      .user-name {
        font-family: PingFang SC, HarmonyOS_Medium, Helvetica Neue,
          Microsoft YaHei, sans-serif;
        font-weight: 500;
        margin-right: 5px;
        color: rgb(251, 114, 153);
        cursor: pointer;
        font-size: 13px;
        .hifu{
            font-size:18px;
          
        }
        .grren{
            color: red;
            }
            .red{
              
                color: #4caf50;
            }
      }
    }

    .root-message {
      .root-reply {
        font-weight: 400;
        box-sizing: border-box;
        color: rgb(24, 25, 28);
        overflow: hidden;
        word-wrap: break-word;
        word-break: break-word;
        white-space: pre-wrap;
        line-height: 24px;
        vertical-align: baseline;
        font-size: 15px;
        text-indent: 2em;
        margin: 0px;
        padding: 0px;
        margin-bottom: 8px;

        p {
          margin: 0px;
          padding: 0px;
        }
      }

      .root-logo {
        display: flex;
        .logos {
          cursor: pointer;
          margin-right: 15px;
          img {
            width: 124px;
            height: 124px;
            border-radius: 8px;
          }
        }
      }
    }
  }
}

p {
  margin: 0px;
  padding: 0px;
}

.page {
  margin-top: 25px;
  display: flex;
  justify-content: center;
}

.reply-list {
  position: relative;
  .sub-reply-container {
    padding-left: 155px;
    display: flex;

    .sub-reply-item {
      position: relative;
      padding: 8px 0 8px 0px;
      border-radius: 4px;

      //   .sub-contetn {
      //   }
      .sub-info {
        flex-wrap: wrap;
        align-items: center;
        display: inline-flex;
        font-size: 13px;
        line-height: 24px;
        font-weight: 500;
        margin-right: 5px;
        color: rgb(97, 102, 109);
        cursor: pointer;
        align-items: center;
        padding-right: 5px;
        color: #673ab7;
        .sub-in-logo {
          height: 24px;
          padding-right: 10px;
        }
      }
      .sub-text {
        color: rgb(24, 25, 28);
        overflow: hidden;
        word-wrap: break-word;
        word-break: break-word;
        white-space: pre-wrap;
        line-height: 24px;
        vertical-align: baseline;
        font-size: 15px;
        vertical-align: top;
      }
    }
  }

  .delete {
    position: absolute;
    right: 0px;
    top: 22px;
    cursor: pointer;
  }
}

.sub-reply-list {
  width: 100%;
  border-bottom: 1px solid #eaebed;
}

// .reply-list:hover {
//     .delete{
//         display: block;
//     }
// }

.reply-info {
  .reply-time {
    color: rgb(148, 153, 160);
    font-size: 13px;
    font-weight: 400;
    line-height: 24px;
    margin-right: 20px;
  }
}
</style>